import type { TCalculatorActionTypes } from '.';

export const FieldNames: Record<TCalculatorActionTypes, string> = {
    itemCost: 'Стоимость предмета лизинга',
    initialFee: 'Первоначальный взнос',
    leaseTerm: 'Срок лизинга',
};
